import React from 'react';
import ReactDOM from 'react-dom/client'; 
import { App } from './app/app';
import { unregister } from './registerServiceWorker';

import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { MsalConfig } from './app/msal/msal-config';

unregister();

const root = ReactDOM.createRoot(document.getElementById("root"));

export const msalInstance = new PublicClientApplication(MsalConfig);

msalInstance.initialize().then(() => {
  // ✅ Handle the redirect return before anything else
  msalInstance.handleRedirectPromise().then((response) => {

    if (response) {
      // Coming back from a redirect - set the account
      msalInstance.setActiveAccount(response.account);
    } else {
      // Normal app load - set account if one exists
      if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
      }
    }

    msalInstance.addEventCallback((event) => {
      if (
        event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
        event.eventType === EventType.SSO_SILENT_SUCCESS
      ) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
      }
    });

    root.render(
      <MsalProvider instance={msalInstance}>
        <App instance={msalInstance} />
      </MsalProvider>
    );

  });
});
